import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LineItemReturnModel } from 'src/business/services/client.generated';
import { SourceSet } from 'src/core-lib/umbraco/umbraco-image.model';
import { ImageUtil } from 'src/layout/media/image.util';

@Component({
    selector: 'app-invoice-line',
    templateUrl: './invoice-line.component.html',
    styleUrls: ['./invoice-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceLineComponent {
    image: string;
    srcset: SourceSet[];

    @Input()
    line: LineItemReturnModel;
    @Input()
    addons: LineItemReturnModel[];

    ngOnInit(): void {
        this.srcset = ImageUtil.productCardSrcset(this.line.imageUrl);
        this.image = this.srcset[this.srcset.length -1]?.srcset?.href;
    }
}
